<template>
    <div class="container gap-32 scroll-container">
        <TermosDeUso :showAcceptedButton="false" :showRejectButton="false"/>
    </div>
    
    <FooterButton :textPrimaryButton="'Voltar'" :confirmData="backStatements"/>
</template>
<script>
    import TermosDeUso from '@/termos-de-uso/termosDeUso.vue';
    import FooterButton from '@/cadastro/components/FooterButton.vue';
    import { useRouter } from 'vue-router'

    export default{
    components: {
        TermosDeUso,
        FooterButton
    },
    setup() {
        const router = useRouter();
         
        const backStatements = async () => {
            router.push({name: 'Statements'})
        }

        return {          
           backStatements
        };
      }, 
  }
</script>